
import React from 'react';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Control } from 'react-hook-form';
import { ContactFormValues } from '../ContactFormSchema';

interface NameFieldProps {
  control: Control<ContactFormValues>;
}

const NameField: React.FC<NameFieldProps> = ({ control }) => {
  return (
    <FormField
      control={control}
      name="name"
      render={({ field }) => (
        <FormItem className="transition-all duration-300 hover:shadow-sm rounded-md group">
          <FormLabel className="block text-sm font-medium text-forti-fi-charcoal group-hover:text-forti-fi transition-colors">Your Name</FormLabel>
          <FormControl>
            <Input 
              placeholder="Enter your name" 
              className="mt-1 transition-all focus:ring-2 focus:ring-forti-fi/20"
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default NameField;
